import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { RouterModule } from "@angular/router";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ToastrModule } from "ngx-toastr";
import { CollapseModule } from 'ngx-bootstrap/collapse';

import { AppComponent } from "./app.component";
import { AdminLayoutComponent } from "./layouts/admin-layout/admin-layout.component";

import { BrowserModule } from '@angular/platform-browser';
import { ComponentsModule } from "./components/components.module";

import { AppRoutingModule } from './app-routing.module';
import { AdminLoginComponent } from "./pages/admin-login/admin-login.component";
import { ErrorPageComponent } from "./pages/error-page/error-page.component";
import { ThankyouComponent } from "./pages/thankyou/thankyou.component";
import { UserVerificationComponent } from './pages/user-verification/user-verification.component';
import {
  NgxUiLoaderModule,
  NgxUiLoaderConfig,
  SPINNER,
  POSITION,
  PB_DIRECTION,
  NgxUiLoaderHttpModule
} from 'ngx-ui-loader';
import { AlreadySubmittedComponent } from "./pages/already-submitted/already-submitted.component";
import { NgxIntlTelInputModule } from "ngx-intl-tel-input";
import {VgCoreModule} from '@videogular/ngx-videogular/core';
import {VgControlsModule} from '@videogular/ngx-videogular/controls';
import {VgOverlayPlayModule} from '@videogular/ngx-videogular/overlay-play';
import {VgBufferingModule} from '@videogular/ngx-videogular/buffering';
import { CustomerLayoutComponent } from './layouts/customer-layout/customer-layout.component';
import { FormPageComponent } from './pages/form-page/form-page.component';
import { NgxMaskModule } from 'ngx-mask';
import { SafeUrlPipe } from "./pages/form-page/safeurl.pipe";
import { SafePipe } from "./components/safe.pipe";
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  fgsColor: '#00f',
  fgsType: SPINNER.squareJellyBox, // foreground spinner type
  fgsSize: 30,
  fgsPosition: 'center-center',
  pbDirection: PB_DIRECTION.leftToRight, // progress bar direction
  pbThickness: 5, // progress bar thickness
  pbColor: '#00f',
  logoSize: 80,
  logoUrl: './assets/img/brand/aaddress-logo-white.svg',
  logoPosition: 'center-center',
  text: 'Loading...'
};
@NgModule({
  declarations: [
    AppComponent,
    AdminLayoutComponent,
    AdminLoginComponent,
    ErrorPageComponent,
    ThankyouComponent,
    UserVerificationComponent,
    AlreadySubmittedComponent,
    CustomerLayoutComponent,
    FormPageComponent,
    SafePipe,
    SafeUrlPipe
  ],
  imports: [
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    ComponentsModule,
    BsDropdownModule.forRoot(),
    AppRoutingModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-left',
      preventDuplicates: true,
      timeOut: 2500
    }),
    CollapseModule.forRoot(),    
    BrowserModule,
    AppRoutingModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxIntlTelInputModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    NgxMaskModule.forRoot(),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
